import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  other: '',
  value: [],
};

export const slice = createSlice({
  name: 'country',
  initialState,
  reducers: {
    setCountry: (state, action) => {
      state.value = action.payload;
    }
  },
});

export const { setCountry } = slice.actions;

export const countryList = (state) => {
  return state.country.value;
};

export default slice.reducer;